import {
  Component,
  OnInit,
  Inject,
  Optional,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from 'src/app/common/services/api.service';
import {
  catchError,
  debounceTime,
  filter,
  switchMap,
  tap,
} from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '../../services/message.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { CROSS } from 'src/defaultImages.js';
import { LOYALTY_ENUMS } from '../../enums/loyalty.enum';

@Component({
  selector: 'app-add-loyalty-cashback',
  templateUrl: './add-loyalty-cashback.component.html',
  styleUrls: ['./add-loyalty-cashback.component.css'],
})
export class AddLoyaltyCashbackComponent implements OnInit, AfterViewInit {
  images = {
    CROSS: CROSS,
  };
  Currency;
  status: any;
  requesttype: string;
  actionAfterClose: string;
  customerForm: FormGroup;
  currentTitle: string;
  modalState = {
    showOrderType: false,
    showCustomer: false,
    showTable: false,
    showEditPax: false,
    showPlatformOrderType: false,
  };
  selectedOrder = {
    id: null,
    name: '',
    platform: '',
  };
  areInputFieldsDisabled: boolean = false;
  isApiRequestLoading: boolean = false;
  showLoyaltyCashback: boolean = false;
  isLoyaltyLoading: boolean = false;
  loyaltyCashback: any = {};
  applyCashbackChecked: boolean = false;
  loyaltyAutoApply: boolean = false;
  disableLoyaltyCheckbox: boolean = false;
  doesUserExist: boolean = true;
  defaultValue: string = '';
  requestFrom: any = 'cart';
  paxMandatory: any = 0;
  restSettings: any = {};
  currPlatform = '';
  currentUserId: string;
  @ViewChild('calculator', { static: false }) input: ElementRef;
  customerSearch = {
    numberValidityStatus: '',
    nameValidityStatus: '',
    namePlaceHolder: 'Enter Name',
  };

  translationText;
  subscription = new Subscription();
  loyaltyErrorCondition: boolean = false;
  loyaltyTooltipText: string = '';

  constructor(
    public dialogRef: MatDialogRef<AddLoyaltyCashbackComponent>,
    public dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private apiService: ApiService,
    private _eventTracker: EventTrackerService,
    public translateService: TranslateService,
    private messageService: MessageService,
    private curr: CurrencyService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
    this.Currency = this.curr.getCurrency();
    this.customerForm = this.fb.group({
      name: [this.data.name],
      dial_code: [this.data.dialCode],
      number: [this.data.phone],
      user_gender: [this.data.user_gender],
      user_dob: [this.data.user_dob],
    });
  }
  ngOnInit() {
    this.subscription.add(
      this.translateService
        .get(['ORDER_DASHBOARD'])
        .subscribe((translation) => {
          this.translationText = translation.ORDER_DASHBOARD;
          this.customerSearch = {
            numberValidityStatus: '',
            nameValidityStatus: '',
            namePlaceHolder: this.translationText.NAME_PH,
          };
        })
    );
    this.currPlatform = localStorage.getItem('pos_platform');

    this.status = this.data.status;
    this.requesttype = this.data.requesttype;
    this.actionAfterClose = this.data.actionAfterClose;
    this.requestFrom = this.data.requestFrom;
    if (this.data.name !== 'Guest' && this.data.name !== 'easyeat user') {
      this.customerForm.disable();
    }
    // this.areInputFieldsDisabled = this.data.name !== 'Guest'
    if (this.data.name === 'Guest' || this.data.name === 'easyeat user') {
      this.doesUserExist = false;
    }

    if (this.data.userId) {
      this.fetchLoyaltyCashback(this.data.userId);
    }

    this.customerForm.patchValue({
      name: this.data.name,
      dial_code: this.data.dialCode,
      number: this.data.phone,
      user_gender: this.data.user_gender,
      user_dob: this.data.user_dob
    });

    try {
      this.restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      this.paxMandatory = this.restSettings['menu']['pax_mandatory'];
      this.loyaltyAutoApply = this.restSettings['global']['loyalty_auto_apply'];
    } catch (error) {
      this.paxMandatory = 0;
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  ngAfterViewInit() {
    this.customerForm
      .get('number')
      .valueChanges.pipe(
        tap((i) => (this.customerSearch.numberValidityStatus = null)),
        filter((i) => i.length >= 7),
        debounceTime(400),
        switchMap((searchTerm) =>
          this.getUserDetails(searchTerm).pipe(
            catchError((err) =>
              of({
                error: 'Not Found',
                message: this.translationText.NO_RECORD,
                statusCode: 404,
              })
            )
          )
        )
      )
      .subscribe((response: any) => {
        if (response.statusCode === 201) {
          this.customerSearch.numberValidityStatus = 'success';
          this.customerSearch.nameValidityStatus = null;
          this.customerSearch.namePlaceHolder = this.translationText.NAME_PH;
          this.customerForm.patchValue({
            name: (response.data || {}).name || '',
          });
          this.currentUserId = response.data.user_id;
          this.doesUserExist = true;
          this.fetchLoyaltyCashback(response.data.user_id);
        } else {
          this.customerSearch.numberValidityStatus = null;
          this.customerSearch.nameValidityStatus = null;
          this.customerSearch.namePlaceHolder = this.translationText.NO_RECORD;
          this.customerForm.patchValue({ name: '' });
          setTimeout(() => {
            this.customerSearch.namePlaceHolder = this.translationText.NAME_PH;
          }, 2000);
          this.showLoyaltyCashback = false;
          this.doesUserExist = false;
        }
      });
  }

  getLoyaltyTooltipText(){
    if (this.loyaltyCashback.total_credits === 0) return this.loyaltyTooltipText = this.translationText.NO_CASHBACK_AVAILABLE;
    if (this.disableLoyaltyCheckbox) return this.loyaltyTooltipText = `${this.translationText.ADD_ITEMS_WORTH} ${this.Currency} ${this.data.minLoyaltyRedeem - this.data.itemTotal} ${this.translationText.MORE_TO_APPLY}`;
    return this.loyaltyTooltipText = '';
   }
   
  isLoyaltyRedeemable(data) {
    const itemTotalExists = data.itemTotal !== undefined
    const minRedeemExists = data.minLoyaltyRedeem !== undefined
  
    return (itemTotalExists && minRedeemExists && data.itemTotal < data.minLoyaltyRedeem);
  }
  
   getLoyaltyErrorCondition() {
    const loyaltyNotLoading = !this.isLoyaltyLoading;
    const hasNonZeroCredits = (this.loyaltyCashback || {}).total_credits !== 0;
  
    if (loyaltyNotLoading && hasNonZeroCredits && this.isLoyaltyRedeemable(this.data)) {
      return this.loyaltyErrorCondition = true;
    }
    
    this.loyaltyErrorCondition = false;
  }

  fetchLoyaltyCashback(userId: string) {
    this.isLoyaltyLoading = true;
    this.getUserCredits(
      userId,
      localStorage.getItem('restaurant_id')
    ).subscribe((response: any) => {
      const { data } = response;
      this.loyaltyCashback = (data || {});
      this.showLoyaltyCashback = true;
      this.isLoyaltyLoading = false;
      this.getLoyaltyErrorCondition();
      if (
        data.total_credits !== 0 && this.data.itemTotal >= this.data.minLoyaltyRedeem
      ) {
        this.disableLoyaltyCheckbox = false;
        if (this.loyaltyAutoApply) {
          this.applyCashbackChecked = true;
        } else {
          this.applyCashbackChecked = false;
        }
      } else {
        this.applyCashbackChecked = false;
        this.disableLoyaltyCheckbox = true;
      }

      this.getLoyaltyTooltipText();
    });
  }

  getUserCredits(userId: string, restaurantId: string) {
    return this.apiService.getWallet(userId, restaurantId);
  }

  getUserDetails(searchTerm) {
    this.customerSearch.numberValidityStatus = null;
    this.customerSearch.nameValidityStatus = 'validating';
    this.customerSearch.namePlaceHolder = this.translationText.SEARCHING;
    const payload = {
      dial_code: this.customerForm.get('dial_code').value,
      phone: searchTerm,
    };
    return this.apiService.getUserDetailsByContact(payload);
  }

  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }

  handleCashbackCheckbox(event) {
    this.applyCashbackChecked = event.target.checked;
  }

  userDetailsClicked() {
    this.customerForm.markAllAsTouched();
    if (this.customerForm.valid) {
      localStorage.setItem('pos_user_details_set', '1');
    }

    if (this.applyCashbackChecked) {
      this.isApiRequestLoading = true;
      const redeemLoyaltyParams = {
        order_id: this.data.orderId,
        action: LOYALTY_ENUMS.APPLY,
        full_redeem: true,
        user_id: this.currentUserId || this.data.userId,
      };
      this.apiService
        .redeemLoyaltyOnOrder(redeemLoyaltyParams)
        .subscribe((response) => {
          this.isApiRequestLoading = false;
          if (response.statusCode === 200) {
            this.messageService.showSuccess(
              this.translationText.LOYALTY_CASHBACK_APPLIED
            );
            this.dialogRef.close({message: LOYALTY_ENUMS.LOYALTY_APPLIED_ON_ORDER});
          }
        });
    }

    this._eventTracker.easyeat_track_event('CUSTOMER_DETAILS_SAVED', {
      'Order Source': 'POS',
      'CUSTOMER NAME': this.customerForm.value.name,
      'DIAL CODE': this.customerForm.value.dial_code,
      'CUSTOMER MOBILE NUMBER': this.customerForm.value.number,
    });

    this._eventTracker.easyeat_track_event('CUSTOMER_DETAILS_SAVED', {
      'DIAL CODE': this.customerForm.value.dial_code || 'N/A',
      'CUSTOMER MOBILE NUMBER': this.customerForm.value.number || 'N/A',
    });
  }

  checkInput(ev, type) {
    if (
      (type === 'name' && !/^[A-Za-z\s]*$/.test(ev.target.value)) ||
      (type === 'dial_code' && !/^([+][0-9]*)$/.test(ev.target.value)) ||
      (type === 'phone' && !/^[0-9]*$/.test(ev.target.value))
    ) {
      ev.target.value = null;
    }
  }
}
